import { observer } from "mobx-react";
import React from "react";
import { generalConfigurationStore } from "../Stores/GeneralConfigurationStore";

type Props = {
	isSelected: boolean;
	onChange: () => void;
	emptyText: string;
};


@observer
class EmptyStateTile extends React.Component<Props> {


	render() {
		let url = generalConfigurationStore.configs?.independentModulesStepNotSelectedPlaceholderImage?.url;

		return (
			<>
				<div className={`module-tile empty-tile ${!this.props.isSelected ? "selected" : ""}`} onClick={(e) => this.props.onChange()}>
					<div className="module-image-wrapper">
						{url &&
							<img
							className="module-image"
							src={url}
							alt={this.props.emptyText}
						/>
						}
						<div className="module-selected"></div>
					</div>
					<div className="module-wrapper">
						<div className="module-name">
							<span>{this.props.emptyText}</span>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default EmptyStateTile;
